import type { ProviderFactoryConfig, ProviderFactoryWithOptions } from '@standardagents/spec';
import { GoogleProvider } from './GoogleProvider';
import { googleProviderOptions } from './providerOptions';

/**
 * Google Gemini / Imagen provider factory for Standard Agents.
 */
export const google: ProviderFactoryWithOptions<typeof googleProviderOptions> = Object.assign(
  (config: ProviderFactoryConfig) => new GoogleProvider(config),
  { providerOptions: googleProviderOptions }
);

export { googleProviderOptions, type GoogleProviderOptions } from './providerOptions';
export { GoogleProvider } from './GoogleProvider';
export {
  calculateGoogleUsageCost,
  getGoogleModelPricing,
  type GoogleModelPricing,
} from './pricing';
